import { base } from 'grommet';
import { deepMerge } from 'grommet/utils/object';

export default deepMerge(base, {});
